export default __webpack_public_path__ + "img/dmMJUltG.51b4dd29.svg";